import React from 'react'
import slideLayoutDefinitions from '../../../../staticData/slideLayoutDefinitions.js'

class StaticSlideZoomableFillAnimatedGIF extends React.Component{


  render(){
    const {slideTemplate, questionMediaDynamicHeight} = this.props

    const imageContainerWidth = slideLayoutDefinitions.bodyMediaContainerDimensions[`${slideTemplate}`].width
    let imageContainerHeight = slideLayoutDefinitions.bodyMediaContainerDimensions[`${slideTemplate}`].height

    if(slideTemplate === 'bodyCenterMediaCenter'){
      imageContainerHeight = questionMediaDynamicHeight
    }
      
    return(             
      <div id="fillAnimatedGIFZoomable" style={{width: `${imageContainerWidth}px`, height: `${imageContainerHeight}px`}}  className='slide-media--imageCover slide-media--imageCover--fill'>
        {/*          
          Image Container Width: {imageContainerWidth}<br/>
          Image Container Height: {imageContainerHeight}<br/>          
        */}
      </div>
    )   
  } 
}


export default StaticSlideZoomableFillAnimatedGIF
